import { localStorageKey } from '../../../common/utils/constant';
import { COMMON_LOAD_COLLECTION_CHANGE } from './constants';

export function loadCollectionChange() {
  let updatedCollections = localStorage.getItem(localStorageKey.UPDATE_COLLECTION);
  if (updatedCollections) {
    updatedCollections = JSON.parse(updatedCollections);
  } else {
    updatedCollections = [];
  }
  return {
    type: COMMON_LOAD_COLLECTION_CHANGE,
    data: updatedCollections,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_LOAD_COLLECTION_CHANGE:
      return {
        ...state,
        updatedCollections: action.data,
      };

    default:
      return state;
  }
}
